import React from "react";
import Heading from "../../common/Heading";
import "./Featured.css";
import FeaturedCard from "./FeaturedCard";

const Featured = () => {
  return (
    <>
      <section className="featured background">
        <div className="container">
          <Heading title="News and Articles" subtitle="Know more about our work." />
          <FeaturedCard type="featured" /> {/* Passing type="featured" */}
        </div>
      </section>
    </>
  );
};

export default Featured;
